import { Divider, DividerProps } from "@mantine/core";

const DividerComponent = ({ ...props }: DividerProps) => {
  return <Divider data-testid="divider" {...props} />;
};

export default DividerComponent;
